import { IGetProjetoRevisaoByIdUseCase } from "../../../presentation/useCases/read/get_projeto_revisao_by_id_use_case";
import { ProjetoRevisaoModel } from "../../models/revisao_projeto";

import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * GetProjetoRevisaoByIdUseCase
 */

export class GetProjetoRevisaoByIdUseCase implements IGetProjetoRevisaoByIdUseCase {
  constructor(private readonly repository: IProjetosRepository) { }

  async execute(
    idProjetoRevisao: number,
  ): Promise<ProjetoRevisaoModel> {
    return await this.repository.getProjetoRevisaoById(idProjetoRevisao);

  }
}
